import { createMuiTheme } from '@material-ui/core';
import { ptBR } from '@material-ui/core/locale';

import palette from './palette';
import typography from './typography';
import components from './components';

const theme = createMuiTheme({
  palette,
  typography,
  components,
  zIndex: {
    appBar: 5,
    drawer: 1100
  }
}, ptBR);

export default theme;
